import type { IconProps } from "./types";

export function CircleInfoBold({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 7.59961C9.50294 7.59961 9.09961 8.00294 9.09961 8.5V14.5C9.09961 14.9971 9.50294 15.4004 10 15.4004C10.4971 15.4004 10.9004 14.9971 10.9004 14.5V8.5C10.9004 8.00294 10.4971 7.59961 10 7.59961ZM10 4.09961C9.50294 4.09961 9.09961 4.50294 9.09961 5C9.09961 5.49706 9.50294 5.90039 10 5.90039H10.0098C10.5068 5.90039 10.9102 5.49706 10.9102 5C10.9102 4.50294 10.5068 4.09961 10.0098 4.09961H10Z"
        fill={currentColor}
        transform="translate(2 2)"
      />
    </svg>
  );
}
